import './spinner.scss'

export function Spinner() {
    return (
        <div className="spinner-component">
            <div className="spinner"></div>
        </div>
    )
}